var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWineGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58929 2.93348C6.62672 2.40818 7.09306 2 7.65576 2H16.3442C16.9069 2 17.3733 2.40818 17.4107 2.93348L17.5045 4.25H6.49548L6.58929 2.93348Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3886 5.75H17.6114L17.9864 11.0133C18.1992 13.9993 15.8829 16.5664 12.8016 16.9505V20.5H15.2065C15.6493 20.5 16.0082 20.8358 16.0082 21.25C16.0082 21.6642 15.6493 22 15.2065 22H8.7935C8.35077 22 7.99187 21.6642 7.99187 21.25C7.99187 20.8358 8.35077 20.5 8.7935 20.5H11.1984V16.9505C8.11712 16.5664 5.80079 13.9993 6.01356 11.0133L6.3886 5.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineGlass);
export default __webpack_public_path__ + "static/media/wine-glass.f66659062efe0d8e11a2d2fc558eee7d.svg";
export { ForwardRef as ReactComponent };